import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { MessageService } from 'primeng/api';
import { Subject, filter, takeUntil } from 'rxjs';
import { WtrTabViewEnum } from '../../enums/wtr-tabview.enum';
import { VenueService } from '../../services/venues/venue.service';
import { VenueModel } from 'src/app/pos-panel/models/venues/venue.model';
import { CapacityService } from '../../services/capacity/capacity.service';
import { CapacityModel } from '../../models/capacity/capacity-model';
import { CapacityGroupModel } from '../../models/capacity/capacity-group.model';
import { CapacityTableStatusEnum } from '../../enums/capacity-table-status.enum';
import {OrderService} from "../../services/order/order.service";
import {AuthenticationService} from "../../../share-modul/services/authentication/authentication.service";
import {OrderDetailsModel} from "../../models/orders/order-bill.model";
import {OrderStatusEnum} from "../../enums/order-status.enum";


@Component({
  selector: 'app-waiter-tabview',
  templateUrl: './waiter-tabview.component.html',
  styleUrls: ['./waiter-tabview.component.scss']
})
export class WaiterTabviewComponent implements OnInit {
  //#region Fields
  public unsubscribe: Subject<void> = new Subject<void>();
  public activeIndex: number = 0;
  public spinner: boolean = false;
  public venueId: string;
  public venueName: string;
  public tablesInfo: any = {};
  public capacity: CapacityModel;
  public capacityGroupList: Array<CapacityGroupModel>;
  public selectedCapacityGroupIndex: number;
  public TableHasOrder: CapacityTableStatusEnum = CapacityTableStatusEnum.hasOrder;
  public currentWaiter: any;
  public orderBills: { [key: string]: Array<OrderDetailsModel>} = {};
  public orderBillsList: Array<OrderDetailsModel> = new Array<OrderDetailsModel>();
  public orderStatusEnum: typeof OrderStatusEnum = OrderStatusEnum;

  //#endregion
  //#region Constructor
  constructor(
    public authenticationService: AuthenticationService,
    public venueService: VenueService,
    public capacityService: CapacityService,
    public route: ActivatedRoute,
    private router: Router,
    public translate: TranslateService,
    public messageService: MessageService,
    public orderService: OrderService
  ) {
   }

  ngOnInit(): void {
    this.loadTabIndex();
    this.route.params.subscribe(async params => {
      this.venueId = params['id'];
      this.getWtrByStatus({index: this.activeIndex});
      this.getVenueDetails(this.venueId);
      this.getDefaultCapacityTemplate();
      this.authenticationService.getWaiterProfile().subscribe(response => {
        this.currentWaiter = response;
        this.listOrdersTakenByWaterForVenue();
      });
    });
  }
  //#endregion
  //#region Public Methods
  getWtrByStatus(event: any, refresh: boolean = true): void {
    this.updateTabIndexParam(event.index);
    let status;

    if (event.index === 0) {
      status = WtrTabViewEnum.Tables;
      this.getDefaultCapacityTemplate();
    } else if (event.index === 1) {
      status = WtrTabViewEnum.AllOrders;
    } else if (event.index === 2) {
      status = WtrTabViewEnum.AllBills;
    }

    // if (refresh) {
    // }

    // if (status) {
    // }

  }

  public getVenueDetails(id: string): void {
    this.venueService.getvenuedetails(this.venueId)
      .pipe(takeUntil(this.unsubscribe))
      .subscribe({
        next: (response: VenueModel) => {
          // if (!refresh) {
          this.venueName = response.name;
          // }
        },
        error: errorResponse => {
          this.spinner = false;
          if (errorResponse.error && errorResponse.error.Message) {
            this.messageService.add({ severity: 'error', summary: errorResponse.error.Message, life: 2000 });
          }
          else if (errorResponse.error && !errorResponse.error.errors) {
            this.messageService.add({ severity: 'error', summary: errorResponse.error.title, life: 2000 });
          }
        }
      });
  }

  public getDefaultCapacityTemplate(){
    this.capacityService.viewdefaultcapacitytemplate(this.venueId)
      .pipe(takeUntil(this.unsubscribe))
      .subscribe({
        next: (response: CapacityModel) => {
          this.spinner = false;
          if(response) {
            this.capacity = response;
            this.capacity.capacityGroups.sort((a, b) => a.index - b.index);
            this.tablesInfo = {};
            this.capacity.capacityGroups.forEach(capacityGroup => capacityGroup?.capacityTables.forEach(table => this.tablesInfo[table.id] = table.name));
            this.capacityGroupList = this.capacity.capacityGroups;
            if(this.selectedCapacityGroupIndex == undefined) {
              this.selectedCapacityGroupIndex = 1;
            }
          }
        },
        error: errorResponse => {
          this.spinner = false;
          if (errorResponse.error && errorResponse.error.Message) {
            this.messageService.add({ severity: 'error', summary: errorResponse.error.Message, life: 2000 });
          }
          else if (errorResponse.error && !errorResponse.error.errors) {
            this.messageService.add({ severity: 'error', summary: errorResponse.error.title, life: 2000 });
          }
        }
      })
  }

  public changeCapacityGroupIndex(capacityGroup: CapacityGroupModel){
    this.selectedCapacityGroupIndex = capacityGroup.index;
    this.updateCapacityGroup(capacityGroup.index)
  }

  public openWaiterTable(table: any){
    this.router.navigate(['/waiter', this.venueId, 'wtr', table.id,'table']);
  }

  public loadTabIndex(): void {
    this.route.queryParams
      .subscribe(params => {
        if(params.activeIndex) {
          this.activeIndex = +params.activeIndex;
        }
      if(params.activeGroup) {
        this.selectedCapacityGroupIndex = +params.activeGroup;
      }
    });
  }

  public updateTabIndexParam(activeIndex: number): void {
    this.router.navigate(
      [],
      {
        relativeTo: this.route,
        queryParams: {activeIndex: activeIndex},
        queryParamsHandling: 'merge',
        replaceUrl: true
      })
  }
  public updateCapacityGroup(activeGroup: number): void {
    this.router.navigate(
      [],
      {
        relativeTo: this.route,
        queryParams: {activeGroup: activeGroup},
        queryParamsHandling: 'merge',
        replaceUrl: true
      })
  }

  public listOrdersTakenByWaterForVenue(): void {
   this.orderService.listOrderBillsForWaiterAndVenue(this.currentWaiter.id, this.venueId)
     .pipe(takeUntil(this.unsubscribe))
     .subscribe( response => {
       response.sort((a: OrderDetailsModel, b: OrderDetailsModel) => b.createDate.localeCompare(a.createDate));
       /*let filteredResponseByDate = response.filter((bill: OrderDetailsModel) => {
         let billDate = new Date(bill.createDate);
         let currentDate = new Date();
         return billDate.getDay() == currentDate.getDay() && billDate.getMonth() == currentDate.getMonth() && billDate.getFullYear() == currentDate.getFullYear();
       });*/
       this.orderBillsList = response;
       response.forEach((entry: OrderDetailsModel) => {
           if (Object.keys(this.orderBills).includes(this.tablesInfo[entry.capacityTableId])) {
              this.orderBills[this.tablesInfo[entry.capacityTableId]].push((<OrderDetailsModel> entry));
           }else {
             this.orderBills[this.tablesInfo[entry.capacityTableId]] = [(<OrderDetailsModel> entry)];
           }
     })
   })
  }
  public displayPriceWithTaxWithCalculatedTax(bill: OrderDetailsModel){
    return bill.discount ? (bill.discountPercentage ? bill.priceWithTax - bill.priceWithTax * bill.discount/100 : bill.priceWithTax - bill.discount) : bill.priceWithTax;
  }
  //#endregion

}
